import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { FormField } from './form-field';
export function RangeInput(props) {
    const { value, placeholder, label, onChange } = props;
    const [minimum, maximum] = useMemo(() => value ? value.split(',') : ['', ''], [value]);
    const updateMinimum = useCallback((newMinimum) => {
        onChange([newMinimum, maximum].join(','));
    }, [onChange, maximum]);
    const updateMaximum = useCallback((newMaximum) => {
        onChange(([minimum, newMaximum]).join(','));
    }, [onChange, minimum]);
    return (_jsxs("div", { className: "range-input", children: [_jsx("legend", { children: label }), _jsxs("div", { className: "range-input-inputs", children: [_jsx("div", { className: "range-input-input", children: _jsx(FormField, { type: "number", value: minimum, onChange: updateMinimum, label: 'Min ' + placeholder, placeholder: "Min" }) }), _jsx("div", { className: "range-input-input", children: _jsx(FormField, { type: "number", value: maximum, onChange: updateMaximum, label: 'Max ' + placeholder, placeholder: "Max" }) })] })] }));
}
